export default __webpack_public_path__ + "media/Veggies.d2113b82.png";